import { render, staticRenderFns } from "./BatchAudit.vue?vue&type=template&id=25fdacc6&"
import script from "./BatchAudit.vue?vue&type=script&lang=js&"
export * from "./BatchAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports